import { Component, OnInit } from '@angular/core';
import { NzModalService } from 'ng-zorro-antd/modal';
import { NzMessageService } from 'ng-zorro-antd/message';
import { SparepartsService } from '../../service/spareparts.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { OutDetailComponent } from './out-detail/out-detail.component';
import { DatePipe } from '@angular/common';
import endOfMonth from 'date-fns/endOfMonth';
import startOfMonth from 'date-fns/startOfMonth';

@Component({
  selector: 'app-out-spare',
  templateUrl: './out-spare.component.html',
  styleUrls: ['./out-spare.component.less']
})
export class OutSpareComponent implements OnInit {

  validateForm: FormGroup;
  outTypes = [];
  listOfData = [];
  startRow: number;
  // 分页查询条件
  pageIndex: number;
  pageSize: number;
  total = 0;
  loading = true;
  ranges = { 今天: [new Date(), new Date()], 本月: [startOfMonth(new Date()), endOfMonth(new Date())] };
  private datePipe: DatePipe = new DatePipe('zh-cn');
  constructor(
    private fb: FormBuilder,
    private modal: NzModalService,
    public message: NzMessageService,
    private router: Router,
    private dataService: SparepartsService
  ) {
    this.startRow = 1;
    this.pageIndex = 1;
    this.pageSize = 10;
  }


  ngOnInit(): void {
    this.validateForm = this.fb.group({ typeId: null, spareName: null, date: null });
    this.initTypeData();
    this.queryStockData(1);
  }

  /**
   * 查询出库单类型信息
   */
  async initTypeData() {
    const result = await this.dataService.queryEntryOutType(1);
    if (result === null) {
      return;
    } else {
      for (const data of result) {
        const node = {
          title: data.dictLabel,
          value: data.dictValue,
          key: data.dictValue
        };
        this.outTypes.push(node);
      }
    }


  }

  /**
   * 查询出库单记录数据
   * @param flag 1表示点击搜索按钮，2表示翻页
   */
  async queryStockData(flag: number) {
    if (flag === 1) {
      this.pageIndex = 1;
      this.pageSize = 10;
    }
    const result = await this.dataService.queryOutData(this.validateForm.value, this.pageIndex, this.pageSize);
    this.loading = false;
    if (result.code !== 200) {
      this.message.create('error', '出库记录查询失败!');
      return;
    } else {
      this.listOfData = result.data.list;
      this.listOfData.forEach(element => {
        element.createTime = this.formatDate(element.createTime);
      });
      this.total = result.data.total;
      this.startRow = result.data.startRow;
    }
  }
  /**
   * 格式化Date
   * @param date 日期
   */
  public formatDate(date: any): string {
    return this.datePipe.transform(date, 'yyyy-MM-dd HH:mm:ss');
  }
  submitForm() {
    this.queryStockData(1);
  }

  resetForm() {
    this.validateForm.setValue({ typeId: null, spareName: null, date: null });
    this.queryStockData(1);
  }
  /**
   * 删除出库记录
   */
  async deleteData(stNo: string) {
    this.modal.confirm({
      nzTitle: '<i>确认要删除该出库记录信息?</i>',
      nzOnOk: async () => {
        const result = await this.dataService.deleteOutData(stNo);
        if (result === 0) {
          this.message.create('error', '出库记录删除失败!');
        } else {
          this.message.create('success', '出库记录删除成功!');
          this.queryStockData(2);
        }
      }
    });
  }
  /**
   * 查询出库单详情
   * @param woNo 入库单编号
   */
  async DetailData(woNo: string, wotNo: number, rceiver: string, desc: string, rlNos: string) {
    const modals = this.modal.create({
      nzTitle: '出库单[' + woNo + ']详情',
      nzContent: OutDetailComponent,
      nzStyle: { top: '20px' },
      nzWidth: 1000,
      nzFooter: null,
      nzMaskClosable: false,
      nzComponentParams: {
        outTypes: this.outTypes,
        no: woNo,
        typeId: wotNo,
        receiver: rceiver,
        description: desc,
        rlNo: rlNos
      }
    });
    modals.afterClose.subscribe(
      {
        next: num => {
          if (num === 'success') {
            this.resetForm();
            this.queryStockData(2);
          }
        }
      }
    );
  }

  onPageIndexChange(pageIndex): void {
    this.pageIndex = pageIndex;
    this.queryStockData(2);
  }


  /**
   * 创建入库单
   */
  createEntry() {
    const modals = this.modal.create({
      nzTitle: '创建-出库单',
      nzContent: OutDetailComponent,
      nzStyle: { top: '20px' },
      nzWidth: 1000,
      nzFooter: null,
      nzMaskClosable: false,
      nzComponentParams: {
        outTypes: this.outTypes,
        no: null,
        typeId: 0,
        receiver: null,
      }
    });
    modals.afterClose.subscribe(
      {
        next: num => {
          if (num === 'success') {
            this.resetForm();
            this.queryStockData(1);
          }
        }
      }
    );
  }
  /**
   * 库存数据
   */
  stockData() {
    this.router.navigate(['/web/facility/SparePartsManagement']);
  }
  /**
   * 领料单管理
   */
  getSparParts() {
    this.router.navigate(['/web/facility/TakeSpareParts']);
  }
  /**
   * 入库单管理
   */
  entrySpareParts() {
    this.router.navigate(['/web/facility/EntrySpareParts']);
  }

  onChange(result: Date[]): void {
    // console.log('From: ', result[0], ', to: ', result[1]);
    // console.log('date:' + this.validateForm.value.date[0]);
  }

}
